module.exports = __webpack_public_path__ + "static/10-8065a3b1542b16bc569fde0ae23026e5.jpg";